const REVIEWS_COMPONENT_TYPES = {
  REVIEWS_SUMMARY: 'reviews-summary',
};

export { REVIEWS_COMPONENT_TYPES };
